import React from 'react';
import PipelineMap from './PipelineMap';
import Container from 'react-bootstrap/Container';
import Section from '../Section';
import './styles.scss';

function PipelineSection() {
  return (
    <Section
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      className="pipeline-section"
    >
      <Container>
        <h2 className="text-center mb-4">Pipeline Network Map</h2>
        <div className="pipeline-map-container">
          <PipelineMap />
        </div>
      </Container>
    </Section>
  );
}

export default PipelineSection;
